export default [
  // { path: '/clientes', component: Main, name: 'clientes.main' },
  {path: '/gerencia/clientes', component: () => import('./components/Lista'), name: 'gerencia.clientes.lista'}
]
